module.exports = __webpack_public_path__ + "static/media/manutencao.f3aca406.gif";